/**
 * Converts AI-output LaTeX delimiters to remark-math compatible syntax.
 * AI often uses \[...\] and \(...\) but remark-math expects $$...$$ and $...$
 */
export function preprocessMath(text) {
  if (!text) return text;
  return text
    .replace(/\\\[/g, "$$")
    .replace(/\\\]/g, "$$")
    .replace(/\\\(/g, "$")
    .replace(/\\\)/g, "$");
}
